import React, { useEffect } from "react";
import Button from "components/Button";
import { useApiActions, useData } from "state/hooks";
import { syncTags } from "cms/state/actions/integrations";
import Field from "containers/Field";
import IconButton from "components/IconButton";
//import PropTypes from 'prop-types';
import "./style.css";
import DateDiff from "components/DateDiff";

function Tag(props) {
    const { title } = props;
    return <div>{title.pl}</div>;
}

function TagsStatus(props) {
    const { tags, label } = props;
    return (
        <div className={"rows gap-sm"}>
            <div>
                <strong>
                    {label} ({tags.length})
                </strong>
            </div>
            <div className={"tags-status-grid grid grid-4"}>
                {tags.map((tag) => (
                    <Tag key={tag.id} {...tag} />
                ))}
            </div>
        </div>
    );
}

TagsStatus.defaultProps = {
    tags: [],
};

function TagsImport(props) {
    const { id } = props;

    const data = useData(props);
    const status = data || {};

    const groups = {
        new: "Nowe tagi",
        removed: "Tagi które zostaną usunięte",
        conflicts: "Konflikty ID",
        updated: "Zaimportowane tagi",
    };

    return (
        <div className={"rows gap-md"}>
            {Object.keys(groups).map((key) => (
                <>
                    {status[key]?.length > 0 && (
                        <TagsStatus
                            key={key}
                            label={groups[key]}
                            tags={status[key]}
                        />
                    )}
                </>
            ))}
        </div>
    );
}

export function ZuuInternal(props) {
    const { id } = props;

    const data = useData(props);

    const { onSyncTags } = useApiActions({
        onSyncTags: syncTags,
    });

    const handleSyncTagsPreview = () => {
        onSyncTags(id);
    };

    const handleSyncTags = () => {
        onSyncTags(id, true);
    };

    useEffect(() => {
        onSyncTags(id);
    }, [id, onSyncTags]);

    return (
        <>
            <Field
                id={"tags_entry_types"}
                fieldType={"select"}
                source={"schema:entries.types"}
                label={"Importuj tagi dla"}
                multiple={true}
            />
            <div className={"cols cols-middle cols-spread"}>
                <div>
                    Ostatnia aktualizacja:{" "}
                    {data.tags_synced_at ? (
                        <DateDiff value={data.tags_synced_at} />
                    ) : (
                        "nigdy"
                    )}
                </div>
                <div className={"cols cols-middle"}>
                    <IconButton
                        icon={"mui-refresh"}
                        onClick={handleSyncTagsPreview}
                    />
                    <Button onClick={handleSyncTags}>Aktualizuj tagi</Button>
                </div>
            </div>
            <TagsImport type={"cms.integrations.tags"} id={id} />
        </>
    );
}

ZuuInternal.propTypes = {};

ZuuInternal.defaultProps = {};

export default ZuuInternal;
